import { useEffect, useState } from "react";
import { isActiveEmp } from "../lib/constants";
import { toast } from "sonner";
import { Fingerprint, Loader2, X } from "lucide-react";
import { Switch } from "./ui/switch";
import { Button } from "./ui/button";
import { api } from "../lib/api";

export const AttendanceBioSettings = ({ employees }) => {
  const [s, setS] = useState(null);
  const [pick, setPick] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.attBioSettings().then(setS).catch(() => setS({ required_all: false, exceptions: [] })); }, []);
  if (!s) return null;
  const byId = Object.fromEntries(employees.map((e) => [e.id, e]));
  const save = async (next) => {
    setBusy(true);
    try { setS(await api.saveAttBioSettings(next)); toast.success("تم حفظ إعداد البصمة"); }
    catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الحفظ"); } finally { setBusy(false); }
  };
  const add = () => { if (pick && !s.exceptions.includes(pick)) save({ ...s, exceptions: [...s.exceptions, pick] }); setPick(""); };
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 space-y-3" data-testid="att-bio-settings">
      <div className="flex items-center justify-between gap-3">
        <div>
          <p className="font-heading font-bold text-slate-700 text-sm flex items-center gap-1.5"><Fingerprint className="h-4 w-4 text-emerald-600" /> إلزام البصمة في الحضور والانصراف</p>
          <p className="text-xs text-slate-500 mt-0.5">عند التفعيل لا يستطيع الموظف تسجيل حضوره أو انصرافه من البوابة إلا ببصمة جواله.</p>
        </div>
        <div className="flex items-center gap-2">
          {busy && <Loader2 className="h-4 w-4 animate-spin text-slate-400" />}
          <Switch data-testid="att-bio-required-all" checked={s.required_all} disabled={busy} onCheckedChange={(v) => save({ ...s, required_all: v })} />
        </div>
      </div>
      <div className="rounded-xl bg-slate-50 border border-slate-100 p-3 space-y-2">
        <p className="text-xs font-semibold text-slate-600">{s.required_all ? "مستثنون من البصمة (اختياري لهم):" : "ملزمون بالبصمة فقط:"}</p>
        <div className="flex flex-wrap gap-1.5" data-testid="att-bio-exceptions">
          {s.exceptions.length === 0 && <span className="text-xs text-slate-400">لا يوجد</span>}
          {s.exceptions.map((id) => (
            <span key={id} className="inline-flex items-center gap-1 rounded-full bg-white border border-slate-200 px-2 py-0.5 text-xs">
              {byId[id]?.name || id}
              <button data-testid={`att-bio-remove-${id}`} disabled={busy} onClick={() => save({ ...s, exceptions: s.exceptions.filter((x) => x !== id) })}><X className="h-3 w-3 text-slate-400 hover:text-rose-500" /></button>
            </span>
          ))}
        </div>
        <div className="flex gap-2">
          <select value={pick} onChange={(e) => setPick(e.target.value)} className="h-9 flex-1 min-w-0 rounded-md border border-slate-200 bg-white px-2 text-sm" data-testid="att-bio-pick">
            <option value="">اختر موظف…</option>
            {employees.filter((e) => isActiveEmp(e) && !s.exceptions.includes(e.id)).map((e) => <option key={e.id} value={e.id}>{e.name}{e.is_supervisor ? " (مشرف داخلي)" : ""}</option>)}
          </select>
          <Button size="sm" className="h-9" disabled={!pick || busy} onClick={add} data-testid="att-bio-add">إضافة</Button>
        </div>
      </div>
    </div>
  );
};
